module.exports = __webpack_public_path__ + "img/SMT_24_Ms_Rebecca_Chong.19f4fad4.jpg";